export default "__VITE_ASSET__D8iLwt79__"